import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-white tech-grid-light py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-219" data-mp="o5hzekipto28">
      <div className="mx-auto max-w-4xl px-4" data-id="element-220" data-mp="j7yg3675ul3f">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-221" data-mp="j53v9dk8iy9h">
          Todo lo que incluye
        </h2>
        <p className="mt-3 text-center text-muted" data-id="element-222" data-mp="1bvkr2zipws0b">
          {productName} · {totalVolumes} tomos + {totalBonuses} bonos · <b className="text-ink" data-id="element-223" data-mp="16vpxupbgzqc3">{price}</b>
        </p>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-224" data-mp="12v63tum712u6">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="flex gap-3 rounded-lg border border-line bg-cream p-4" data-id="element-225" data-mp="3rn0ar1xp5d7e">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage" data-id="element-226" data-mp="3nleqgviu1wn6">
                <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-227" data-mp="3id5xxxm6b7he" />
              </span>
              <p data-id="element-228" data-mp="3ncitr7v0vow4">
                <b className="block text-sm text-ink" data-id="element-229" data-mp="3naxyth4sq3xq">{feature}</b>
                <span className="text-sm text-muted" data-id="element-230" data-mp="39c7zduui7s67">{detail}</span>
              </p>
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-xl border-l-4 border-earth bg-cream px-6 py-5 text-center text-lg font-bold leading-relaxed text-ink" data-id="element-231" data-mp="3dda24lnmqmcx">
          “El mejor momento para tener este material era al inicio del año. El segundo mejor momento es hoy.”
        </blockquote>
      </div>
    </section>;
}